import { Note } from "common";
import { NoteBody } from "./NoteBody";
import { Text, Link } from "@chakra-ui/react";
import { Link as ReactRouterLink } from "react-router-dom";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { useNoteAccount } from "./useNoteAccount";
import { useNoteAccountName } from "./useNoteAccountName";

interface NoteUpdateTeamBodyProps {
  note: Note;
}

export const NoteUpdateTeamBody = ({ note }: NoteUpdateTeamBodyProps) => {
  const account = useNoteAccount(note);
  const accountName = useNoteAccountName(note);
  return (
    <NoteBody note={note}>
      <Text width={"100%"} textAlign={"center"} marginLeft={2} marginRight={2}>
        <Link
          color={THEME_COLOR_SCHEME}
          as={ReactRouterLink}
          to={`/account/${account?.id}`}
        >
          {accountName}
        </Link>
        {note.message}
      </Text>
    </NoteBody>
  );
};
